import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../../../components/CustomTooltip";
import {
  getPrettyDateTime,
  useLocalTime,
} from "../../../../../../../utils/timestamp";

const SnoozeInformationIcon = ({ misconfiguration }) => {
  const showLocalTime = useLocalTime();
  const colors = useColors();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <CustomToolTip
        title={
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 500 }}>
              Snoozed On:{" "}
            </Typography>
            <Typography variant="caption">
              {getPrettyDateTime(
                misconfiguration?.snooze_details?.snoozed_at?.timestamp_utc,
                showLocalTime
              )}{" "}
              by{" "}
              {misconfiguration?.snooze_details?.snoozed_by_name ??
                misconfiguration?.snooze_details?.snoozed_by_email}
            </Typography>

            {misconfiguration?.snooze_details?.snoozed_until?.timestamp_utc && (
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  Snoozed Until:{" "}
                </Typography>
                <Typography variant="caption">
                  {getPrettyDateTime(
                    misconfiguration?.snooze_details?.snoozed_until
                      ?.timestamp_utc,
                    showLocalTime
                  )}
                </Typography>
              </Box>
            )}

            {misconfiguration?.snooze_details?.reason && (
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  Reason:{" "}
                </Typography>
                <Typography variant="caption">
                  {misconfiguration?.snooze_details?.reason}
                </Typography>
              </Box>
            )}
          </Box>
        }
        placement="top"
      >
        <InfoIcon
          sx={{
            width: "16px",
            height: "16px",
            color: colors.tooltip_info_icon,
            cursor: "pointer",
          }}
        />
      </CustomToolTip>
    </Box>
  );
};

export default SnoozeInformationIcon;
